import {Component} from 'substance'

class ReadModeSettings extends Component {
    constructor(...args) {
        super(...args)

        // Defined fields for this extension module
        this.fields = {
            'active': 'Activate read mode'
        }
    }

    render($$) {
        const el = $$('div').append(
            $$('h3').addClass('clear').append(
                this.getLabel('Read mode')
            )
        )

        Object.keys(this.fields).forEach((key) => {
            let value = ''

            /*
             * Incoming key/values from the writer is available in this.props.properties
             */
            if (this.props.properties && typeof this.props.properties[key] !== 'undefined') {
                value = this.props.properties[key]
            }

            // Setting keys are namespaced automatically
            if (key === 'active') {
                el.append(
                    this.renderInputOption($$, key, this.fields[key], value)
                )
            }
        })

        return el
    }

    renderInputOption($$, key, name, value) {
        const UIToggle = this.context.componentRegistry.get('UIToggle')

        return $$('div')
            .addClass('form-group')
            .append(
                $$(UIToggle, {
                    id: 'crop-toggle',
                    label: this.getLabel(name),
                    checked: value ? true : false,
                    onToggle: (checked) => {
                        // Tell the writer that the value for a key have changed
                        this.props.onChange(key, checked)
                    }
                })
            )
    }
}

export {ReadModeSettings}
